import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.VERIFY_EMAIL_CHANGE_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.VERIFY_EMAIL_CHANGE_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.VERIFY_EMAIL_CHANGE_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_ACCOUNT_CHANGE_DATA:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
